import moment from "moment";

export function convertToLocalString(date: string, format?: string): string {
  return date ? moment.utc(date).local().format(format) : "";
}

export function convertToLocalDate(date: string, format?: string): Date {
  return new Date(moment.utc(date).local().format(format));
}
